import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../Interceptor/auth.service';
import { SessionStorageService } from '../sessionStorageService/session-storage.service';
import { BaseService } from '../Base/BaseService';
import { CreateAgencyRequest } from 'src/app/Model/createAgencyRequest.model';
import { TradeResponse } from 'src/app/Model/TradeModels/TradeResponse.model';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CreateLegalRepresentativeRequest } from 'src/app/Model/createLegalRepresentativeRequest';
import { CreatePortalAdminRequest } from 'src/app/Model/CreatePortalAdminRequest.model';

@Injectable({
  providedIn: 'root'
})
export class PiaFlowsValidationService extends BaseService{

  constructor(public http: HttpClient, public lsService: SessionStorageService, authService: AuthService, private readonly router: Router, private readonly spinner: NgxSpinnerService) {
    super(http, lsService, authService);
    this.Component = "PiaFlowsValidationService";
  }

  public async canCreateAgency(request: CreateAgencyRequest){
    let response: TradeResponse;
    await this.PostData(request,"PiaFlowsValidation","CanCreateAgency").then(async (res) => {
      if(res.head.status != "False")
        response = JSON.parse(res.body.response);
      else{
        await this.spinner.hide();
        await Swal.fire({
          title: res.head.error.description,
          text: res.body.response,
          icon: 'error',
          timer: 2000
        }).then( async () => {
          this.router.navigate(['Register'])
        });
      }
    });
    return response;
  }

  public async CanCreateLegalRepresentative(request: CreateLegalRepresentativeRequest){
    let response: TradeResponse;
    await this.PostData(request,"PiaFlowsValidation","CanCreateLegalRepresentative").then(async (res) => {
      if(res.head.status != "False")
        response = JSON.parse(res.body.response);
      else{
        await this.spinner.hide();
        await Swal.fire({
          title: res.head.error.description,
          text: res.body.response,
          icon: 'error',
          timer: 2000
        }).then( async () => {
          this.router.navigate(['Register'])
        });
      }
    });
    return response;
  }

  public async CanCreatePortalAdministrator(request: CreatePortalAdminRequest){
    let response: TradeResponse;
    await this.PostData(request,"PiaFlowsValidation","CanCreatePortalAdministrator").then(async (res) => {
      if(res.head.status != "False")
        response = JSON.parse(res.body.response);
      else{
        await this.spinner.hide();
        await Swal.fire({
          title: res.head.error.description,
          text: res.body.response,
          icon: 'error',
          timer: 2000
        }).then( async () => {
          this.router.navigate(['Register'])
        });
      }
    });
    return response;
  }

  public async checkIfAgencyExist(request: CreateAgencyRequest){
    let response: TradeResponse;
    await this.PostData(request,"PiaFlowsValidation","checkIfAgencyExist").then(async (res) => {
      if(res.head.status != "False")
        response = JSON.parse(res.body.response);
      else{
        await this.spinner.hide();
        await Swal.fire({
          title: res.head.error.description,
          text: res.body.response,
          icon: 'error',
          timer: 2000
        }).then( async () => {
          this.router.navigate(['Register'])
        });
      }
    });
    return response;
  }
}
